var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"list"}},[_c('span',{staticClass:"lee-tag",style:('color:'+_vm.cor(_vm.item.color)+';background:'+_vm.bg(_vm.item.color)+';border:solid 1px '+_vm.bor(_vm.item.color)+';')},[_vm._v(_vm._s(_vm.item.t)),(_vm.taggroup.closeable)?_c('i',{on:{"click":function($event){return _vm.del(_vm.item)}}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e23d9a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/leevueplugin/src/LeeTag.vue
// module id = dQJb
// module chunks = 170